import { Box, Button, CircularProgress, MenuItem } from "@material-ui/core";
import { Form, Formik } from "formik";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { MyTextField } from "../../../../../components/custom/MyTextField";
import useReceivingOfficeForm from "./useReceivingOfficeForm";

function ReceivingOfficeForm() {
  const {
    classes,
    productionOffices,
    initialValues,
    submit,
    validationSchema,
  } = useReceivingOfficeForm();

  return (
    <Box paddingRight={"0.5rem"}>
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={submit}
      >
        {({ isSubmitting }) => (
          <Form>
            <label className={classes.title}>
              <FormattedMessage id="pqrsdfReceivingOffice" />*
            </label>
            <MyTextField
              name="productionOfficePQRSCiu"
              variant="outlined"
              select
              className={classes.myTextFieldRoot}
              size="small"
            >
              {productionOffices.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.idProductionOffice}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </MyTextField>
            <Box mt={5} display="flex" justifyContent={"center"}>
              <Button
                className={clsx(classes.btn, classes.save)}
                autoFocus
                type={"submit"}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress className={classes.btnLoading} />
                ) : (
                  <FormattedMessage id="Save" />
                )}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}

export default ReceivingOfficeForm;
